/* Academia: progreso (en este dispositivo), cuestionarios y certificado. Sin dependencias. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var KEY = function (h) { return 'aca-' + h; };
  function get(h) { try { var v = JSON.parse(localStorage.getItem(KEY(h)) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function set(h, a) { try { localStorage.setItem(KEY(h), JSON.stringify(a)); } catch (e) {} }

  function paint(scope) {
    var h = scope.getAttribute('data-aca-course'); if (!h) return;
    var total = parseInt(scope.getAttribute('data-aca-total'), 10) || 0;
    var done = get(h);
    $$('[data-aca-l]', scope).forEach(function (li) { li.classList.toggle('is-done', done.indexOf(li.getAttribute('data-aca-l')) > -1); });
    var pct = total ? Math.round(Math.min(done.length, total) / total * 100) : 0;
    $$('[data-aca-bar]', scope).forEach(function (b) { b.style.width = pct + '%'; });
    $$('[data-aca-pct]', scope).forEach(function (b) { b.textContent = pct + ' %'; });
    var lesson = scope.getAttribute('data-aca-lesson');
    var btn = $('[data-aca-done]', scope);
    if (btn && lesson) {
      var isDone = done.indexOf(lesson) > -1;
      btn.textContent = isDone ? 'Completada ✓ (pulsa para desmarcar)' : 'Marcar como completada';
      btn.classList.toggle('is-done', isDone);
    }
    var cert = $('[data-aca-cert]', scope); if (cert) cert.hidden = pct < 100;
    var cont = $('[data-aca-continue]', scope);
    if (cont && done.length) {
      var next = $$('[data-aca-l] a', scope).filter(function (a) { return done.indexOf(a.closest('[data-aca-l]').getAttribute('data-aca-l')) < 0; })[0];
      if (next) { cont.href = next.href; cont.firstChild.textContent = 'Continuar donde lo dejaste '; }
      else { cont.firstChild.textContent = 'Repasar el curso '; }
    }
  }

  var scopes = $$('[data-aca-course]');
  scopes.forEach(paint);

  var reader = $('[data-aca-lesson]');
  if (reader) {
    var h = reader.getAttribute('data-aca-course'), l = reader.getAttribute('data-aca-lesson');
    var b = $('[data-aca-done]', reader);
    if (b) b.addEventListener('click', function () {
      var d = get(h), i = d.indexOf(l);
      if (i < 0) d.push(l); else d.splice(i, 1);
      set(h, d); paint(reader);
    });
    $$('[data-aca-toggle]', reader).forEach(function (t) {
      t.addEventListener('click', function () {
        var on = reader.classList.toggle('side-open');
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });
  }

  /* Cuestionarios: [{"p":"pregunta","o":["A","B"],"c":0,"e":"explicación"}] */
  $$('[data-aca-quiz]').forEach(function (box) {
    var qs; try { qs = JSON.parse(box.getAttribute('data-aca-quiz')); } catch (e) { qs = null; }
    if (!Array.isArray(qs) || !qs.length) return;
    var h2 = document.createElement('h2'); h2.textContent = 'Comprueba lo que has aprendido'; box.appendChild(h2);
    var ok = 0, answered = 0;
    qs.forEach(function (q, qi) {
      var f = document.createElement('fieldset'); f.className = 'q';
      var lg = document.createElement('legend'); lg.textContent = (qi + 1) + '. ' + (q.p || ''); f.appendChild(lg);
      (q.o || []).forEach(function (o, oi) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'opt'; b.textContent = o;
        b.addEventListener('click', function () {
          if (f.getAttribute('data-done')) return;
          f.setAttribute('data-done', '1'); answered++;
          var right = oi === q.c; if (right) ok++;
          b.classList.add(right ? 'ok' : 'ko');
          var opts = f.querySelectorAll('.opt'); if (!right && opts[q.c]) opts[q.c].classList.add('ok');
          var e = document.createElement('p'); e.className = 'exp'; e.textContent = (right ? 'Correcto. ' : 'No es esa. ') + (q.e || ''); f.appendChild(e);
          if (answered === qs.length) { var r = document.createElement('p'); r.className = 'score'; r.textContent = 'Resultado: ' + ok + ' de ' + qs.length + ' aciertos.'; box.appendChild(r); }
        });
        f.appendChild(b);
      });
      box.appendChild(f);
    });
  });

  /* Certificado privado de finalización (se abre en una ventana para imprimir o guardar en PDF) */
  var cb = $('[data-aca-cert-btn]');
  if (cb) cb.addEventListener('click', function () {
    var input = $('[data-aca-cert-name]');
    var name = (input && input.value || '').trim();
    if (!name) { if (input) input.focus(); return; }
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var course = cb.getAttribute('data-course'), school = cb.getAttribute('data-school') || '', n = cb.getAttribute('data-lessons');
    var d = new Date(), date = d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });
    var code = (school.replace(/\W/g, '').slice(0, 3) || 'CER').toUpperCase() + '-' + d.getFullYear() + '-' + Math.random().toString(36).slice(2, 8).toUpperCase();
    var html = '<!doctype html><html lang="es"><head><meta charset="utf-8"><title>Certificado · ' + esc(course) + '</title>' +
      '<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,800&family=Figtree:wght@400;600&display=swap">' +
      '<style>@page{size:A4 landscape;margin:0}body{margin:0;font-family:Figtree,system-ui,sans-serif;color:#0E1A2B;background:#FBF8F1}' +
      '.c{box-sizing:border-box;width:297mm;height:210mm;padding:22mm 26mm;display:flex;flex-direction:column;justify-content:space-between;border:10mm solid #0E1A2B;background:#FBF8F1;position:relative}' +
      '.c:after{content:"";position:absolute;right:26mm;top:22mm;width:34mm;height:34mm;border-radius:50%;background:#C8F53C}' +
      '.k{font:700 12px/1 monospace;letter-spacing:.2em;text-transform:uppercase;color:#4B7A00}h1{font:800 46px/1.05 "Bricolage Grotesque",sans-serif;margin:10mm 0 6mm}' +
      '.n{font:800 40px/1.1 "Bricolage Grotesque",sans-serif;border-bottom:2px solid #0E1A2B;display:inline-block;padding-bottom:3mm}p{font-size:16px;line-height:1.6;max-width:190mm}' +
      '.f{display:flex;justify-content:space-between;align-items:flex-end;font-size:13px;color:#4A5465}.f b{color:#0E1A2B;font-size:18px}</style></head><body><div class="c">' +
      '<div><div class="k">' + esc(school) + ' · Certificado de finalización</div><h1>' + esc(course) + '</h1>' +
      '<p>Se certifica que</p><div class="n">' + esc(name) + '</div>' +
      '<p>ha completado las ' + esc(n) + ' lecciones de este curso escrito de ' + esc(school) + '.</p></div>' +
      '<div class="f"><div><b>' + esc(date) + '</b><br>Fecha de finalización</div><div style="text-align:right">Código ' + esc(code) + '<br>Certificado privado. No es una titulación oficial.</div></div>' +
      '</div><script>window.onload=function(){setTimeout(function(){window.print()},400)}<\/script></body></html>';
    var w = window.open('', '_blank');
    if (w) { w.document.open(); w.document.write(html); w.document.close(); }
  });
})();
